module.exports = __webpack_public_path__ + "static/img/4_2.ba8d6e2e.jpg";